import React from 'react';
import {
  Box,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon
} from '@chakra-ui/react';

import RichText from '@components/atoms/RichText';
import Wrapper from '@components/atoms/Wrapper';
import { dataLayerFaqClick } from '@helpers/dataLayerPush';

const AccordionBlock = ({ data: { title, accordionBlockItems } }) => {
  const onButtonClick = ({ question, isExpanded }) => {
    dataLayerFaqClick({
      event: `faq`,
      clickText: question,
      interactionType: !isExpanded ? `open` : `close`
    });
  };
  return (
    <Wrapper narrow>
      <Heading
        as="h2"
        color="purple.600"
        fontWeight="900"
        size="lg"
        fontStyle="italic"
        pb="4">
        {title}
      </Heading>
      <Accordion allowMultiple pb="14">
        {accordionBlockItems.map((item, i) => (
          <AccordionItem key={`accordionBlockItems${i + 1}`}>
            {({ isExpanded }) => (
              <>
                <AccordionButton
                  onClick={() => {
                    onButtonClick({
                      question: item.title,
                      isExpanded
                    });
                  }}>
                  <Box flex="1" textAlign="left">
                    {item.title}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <RichText data={item.content.data.content} />
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        ))}
      </Accordion>
    </Wrapper>
  );
};

export default AccordionBlock;
